import React from 'react';
import { Chip, Stack, Typography } from '@mui/material';
import type { FlatExecuteStep } from '@/types/run-stage.types';

interface StepMetadataHeaderProps {
  flatStep: FlatExecuteStep;
}

function getStatusColor(status?: string): 'default' | 'primary' | 'success' | 'warning' | 'error' {
  switch (status?.toUpperCase()) {
    case 'COMPLETED': return 'success';
    case 'IN_PROGRESS': return 'primary';
    case 'SKIPPED': return 'warning';
    case 'ABORTED': return 'error';
    default: return 'default';
  }
}

export const StepMetadataHeader: React.FC<StepMetadataHeaderProps> = ({ flatStep }) => {
  const step = flatStep.step;

  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: 'center', flexWrap: 'wrap', mb: 1 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
        Step {flatStep.pillLabel}
      </Typography>
      <Chip
        label={step.status || 'PENDING'}
        color={getStatusColor(step.status)}
        size="small"
      />
      {step.subType && (
        <Chip label={step.subType} size="small" variant="outlined" />
      )}
      {flatStep.isSubstep && (
        <Chip label="Substep" size="small" variant="outlined" color="info" />
      )}
      {flatStep.cycleLabel && (
        <Chip label={flatStep.cycleLabel} size="small" variant="outlined" color="secondary" />
      )}
      {flatStep.batchLabel && (
        <Chip label={flatStep.batchLabel} size="small" variant="outlined" />
      )}
      {step.isRepeated && (
        <Chip label={`Repeat${step.repeatOrder ? ` #${step.repeatOrder}` : ''}`} size="small" color="info" />
      )}
      {flatStep.checkpoints && flatStep.checkpoints.length > 0 && (
        <Chip label={`${flatStep.checkpoints.length} Checkpoints`} size="small" variant="outlined" />
      )}
      {flatStep.machineChecklists && flatStep.machineChecklists.length > 0 && (
        <Chip label={`${flatStep.machineChecklists.length} Checklists`} size="small" variant="outlined" />
      )}
    </Stack>
  );
};
